<template>
  <div>
    <property-default-tech-select
      @click="handleRowClick"
      v-if="propertyId"
      :property-id="propertyId"
    />
    <div class="d-flex mt-3">
      <service-entity-selector
        class="mr-2"
        v-model="navFullId"
        use-entities
        @clear-items="navFullId = entityId ? [entityId] : []"
        :label="generateMessage('tech_search.fields.nav_full_id')"
      />
      <v-text-field
        class="mx-2"
        :label="generateMessage('tech_search.fields.employee_id')"
        v-model="id"
        outlined
        dense
        clearable
      />
      <v-text-field
        class="mx-2 pb-2"
        :label="generateMessage('tech_search.fields.full_name')"
        v-model="name"
        outlined
        dense
        clearable
      />
      <v-select
        class="mx-2"
        :label="generateMessage('tech_search.fields.role')"
        clearable
        dense
        outlined
        multiple
        item-value="id"
        item-text="shortname"
        :items="roles"
        v-model="role"
      >
        <template v-slot:item="{ item }">
          {{ item.name }}
        </template>
      </v-select>
      <v-select
        class="mx-2"
        :label="generateMessage('tech_search.type')"
        clearable
        multiple
        outlined
        dense
        item-value="id"
        item-text="name"
        :items="positions"
        v-model="type"
      />
      <div>
        <v-checkbox
          dense
          class="ma-0 pa-0"
          hide-details
          :label="generateMessage('tech_search.fields.scheduled')"
          :value="true"
          v-model="scheduled"
        ></v-checkbox>
        <v-checkbox
          dense
          class="ma-0 pa-0"
          hide-details
          :label="generateMessage('tech_search.fields.notScheduled')"
          :value="false"
          v-model="scheduled"
        ></v-checkbox>
      </div>

      <v-tooltip bottom v-if="hasTESTING">
        <template v-slot:activator="{ on }">
          <div v-on="on">
            <v-switch
              class="mx-5"
              :disabled="!isMap"
              inset
              :label="generateMessage('tech_search.cardView.switch.title')"
              v-if="property"
              v-model="mapView"
            />
          </div>
        </template>
        <span>
          {{
            !isMap
              ? generateMessage('tech_search.cardView.switch.error')
              : mapView
              ? generateMessage('tech_search.cardView.switch.list')
              : generateMessage('tech_search.cardView.switch.map')
          }}
        </span>
      </v-tooltip>
    </div>
    <v-data-table
      v-if="!mapView | !hasTESTING"
      dense
      hide-default-footer
      fixed-header
      :no-data-text="generateMessage('tech_search.noItems')"
      disable-sort
      :loading="loading"
      :items-per-page="pageSize"
      :page="pageIndex"
      :headers="hasTESTING ? headersAbs : headers"
      height="350"
      :items="filteredItems"
      item-key="num"
      :item-class="
        (item) => {
          if (item.absence_today && hasTESTING) {
            return 'warning--text';
          } else if (item.scheduled) {
            return 'success--text';
          }
          return;
        }
      "
      class="elevation-1 secondarybackground striped-table"
    >
      <template v-slot:item.entity_nav_full_id="{ item }">
        {{
          item.entity_nav_full_id
            ? `${item.entity_nav_full_id.substring(
                item.entity_nav_full_id.length - 3
              )} - ${item.entity_name}`
            : item.entity_name
        }}
      </template>
      <template v-slot:item.phone="{ item }">
        <v-tooltip bottom max-width="50%" v-if="item.phone_type">
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <span class="font-weight-bold">
                {{ '(' + item.phone_type + ')' }}
              </span>
              {{
                item.phone && item.phone.slice(0, 5) !== 'EMAIL'
                  ? item.phone
                  : item.email
              }}
            </div>
          </template>
          {{ item.other_means ? item.other_means : "Pas d'autre moyen" }}
        </v-tooltip>
      </template>
      <template v-slot:top>
        <div class="d-flex justify-end">
          <custom-page-selector
            class="pa-2"
            :totalItems="filteredItems.length"
            :page-size.sync="pageSize"
            :page-index.sync="pageIndex"
          />
        </div>
      </template>
      <template v-slot:item.absence_today="{ item }">
        <v-tooltip bottom max-width="50%" v-if="item.hours_of_absence">
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-chip small text-color="opposite" color="warning">
                {{ item.absence_today }}
              </v-chip>
            </div>
          </template>
          <span>
            {{ item.hours_of_absence }}
          </span>
        </v-tooltip>
        <span v-else>
          <v-chip
            v-if="item.absence_today"
            small
            text-color="opposite"
            color="warning"
          >
            {{ item.absence_today }}
          </v-chip>
        </span>
      </template>
      <template v-slot:item.specific_status="{ item }">
        {{ item.specific_status.label }}
      </template>
      <template v-slot:item.specific_position="{ item }">
        <div v-if="item.roles.length > 1">
          <div v-for="(role, index) in item.roles" :key="index">
            {{ role }}
          </div>
        </div>
        <div v-else>
          {{ item.specific_position.position }}
        </div>
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn
          class="align-self-end"
          @click="handleRowClick(item)"
          color="primary"
          :disabled="isAssigned(item.id)"
          small
          v-if="
            affectation &&
              (!request || request.request_status < 5 || request.status < 5)
          "
        >
          {{
            isAssigned(item.id)
              ? generateMessage('tech_search.assigned')
              : generateMessage('tech_search.assign')
          }}
        </v-btn>
      </template>
    </v-data-table>
    <loader v-else :is-loading="isLoadingMap" style="height: 64vh;">
      <custom-technician-selector-map
        :affectedTech="affectedTech"
        @input="handleRowClick($event)"
        :filteredStaff="filteredItems"
        :request="request"
        :specialTechnicians="specialTechnicians"
        :affectation="affectation"
        :interventions="interventions"
      />
    </loader>
  </div>
</template>

<script>
import { AUTHORIZATION_MODULE_PATH } from '@/store/modules/authorization';
import { mapGetters } from 'vuex';
import ServiceEntitySelector from '@/components/selects/ServiceEntitySelector';
import CustomPageSelector from '@/components/selects/technician/CustomTechnicianPageSelector';
import CustomTechnicianSelectorMap from '@/components/selects/technician/CustomTechnicianSelectorMap';
import TechniciansResponsibleService from '@/services/services/techniciansResponsible.service';
import getStatus from '@/components/selects/technician/technicianStatus';
import getPosition, {
  getPositions,
} from '@/components/selects/technician/technicianPosition';
import { generateMessage } from '@/utils/i18n';
import Loader from '@/components/widgets/Loader';
import PropertyDefaultTechSelect from '@/components/selects/technician/PropertyDefaultTechSelect';

export default {
  name: 'CustomTechnicianSelector',
  components: {
    CustomPageSelector,
    CustomTechnicianSelectorMap,
    Loader,
    PropertyDefaultTechSelect,
    ServiceEntitySelector,
  },
  computed: {
    ...mapGetters({
      hasTESTING: `${AUTHORIZATION_MODULE_PATH}/hasTESTING`,
    }),
    items() {
      return this.$store.getters[`${this.modulePath}/items`];
    },
    isLoadingMap() {
      return (
        this.$store.getters['technicians/interventions/isLoadingItems'] ||
        this.loading
      );
    },
    isMap() {
      return this.property && this.mapCenterCoordinates !== null;
    },
    loading() {
      return this.$store.getters[`${this.modulePath}/isLoadingItems`];
    },
    mapCenterCoordinates() {
      if (this.property && this.property.longitude && this.property.latitude)
        return [this.property.longitude, this.property.latitude];
      return null;
    },
    pageSizeIndex() {
      return this.$store.getters[`${this.modulePath}/pageSizeIndex`];
    },
    positions() {
      return this.$store.getters[`${this.modulePath}/attributesObjRef`].position
        .values;
    },
    property() {
      if (!this.request) return null;
      return this.request.property ? this.request.property : this.request;
    },
    selectedRoles() {
      return this.role.reduce((acc, id) => {
        const role = this.roles.find((item) => item.id === id);
        if (role && !role.multiple) {
          return acc.concat([this.specialTechnicians[id]]);
        }
        if (role && role.multiple) {
          return acc.concat(this.specialTechnicians[id]);
        }
        return acc;
      }, []);
    },
    filteredItems() {
      return this.items
        .filter(
          (item) =>
            (!this.name ||
              item.full_name.toUpperCase().includes(this.name.toUpperCase())) &&
            (!this.scheduled.length ||
              this.scheduled.includes(item.scheduled)) &&
            (!this.type.length || this.type.includes(item.position)) &&
            (!this.role.length ||
              this.selectedRoles.some((role) => role.id === item.id))
        )
        .map((item) => ({
          ...item,
          specific_position: getPosition(item.id, this.specialTechnicians),
          specific_status: getStatus(item),
          roles: getPositions(item.id, this.specialTechnicians).map(
            (item) => `${item.position}`
          ),
        }));
    },
    navFullId: {
      get() {
        return this.$store.getters[`${this.modulePath}/attributesObj`]
          .entity_nav_full_id.values;
      },
      set(values) {
        this.setFilterAttribute({ attribute: 'entity_nav_full_id', values });
        this.$store.dispatch(`technicians/interventions/setFilterAttribute`, {
          attribute: 'entity_nav_full_id',
          values,
        });
      },
    },
    interventions() {
      return this.$store.getters[
        'technicians/interventions/items'
      ].filter((item) =>
        this.filteredItems.some((tech) => tech.id === item.id)
      );
    },
  },
  props: {
    affectedTech: { type: Object, required: false },
    entityId: { type: String, required: false },
    modulePath: { type: String, required: false, default: 'technicians' },
    propertyId: { type: Number, required: false },
    request: { type: Object, required: false },
    affectation: { type: Boolean, required: false, default: true },
    selection: { type: Boolean, required: false, default: false },
  },
  watch: {
    entityId: {
      handler(value) {
        this.navFullId = value ? [value] : [];
      },
      immediate: true,
    },
    isMap(newVal) {
      this.mapView = newVal;
    },
    name() {
      this.pageIndex = 1;
    },
    id() {
      this.pageIndex = 1;
    },
    type() {
      this.pageIndex = 1;
    },
    scheduled() {
      this.pageIndex = 1;
    },
    propertyId(val) {
      this.loadSpecialTechnicians(val);
    },
  },
  mounted() {
    this.mapView = this.isMap;
    this.setDatesFilter({
      dateMin: new Date(),
    });
    if (this.propertyId) {
      this.loadSpecialTechnicians(this.propertyId);
    }
  },
  methods: {
    isAssigned(id) {
      return this.affectedTech && this.affectedTech.id === id;
    },
    getPositions,
    setSearchOnAttribute(payload) {
      this.$store.dispatch(`${this.modulePath}/setSearchOnAttribute`, payload);
    },
    setDatesFilter(payload) {
      this.$store.dispatch(`${this.modulePath}/setDatesFilter`, payload);
    },
    setFilterAttribute(payload) {
      this.$store.dispatch(`${this.modulePath}/setFilterAttribute`, payload);
    },
    generateMessage,
    handleRowClick(event) {
      if (this.affectation && event.id) {
        this.$emit('input', event);
      }
    },
    loadSpecialTechnicians(propertyId) {
      TechniciansResponsibleService.getTechnicians(propertyId).then((res) => {
        this.specialTechnicians = res;
      });
    },
  },
  data() {
    return {
      headersAbs: [
        {
          value: 'employee_id',
          text: this.generateMessage('tech_search.fields.employee_id'),
          position: 'center',
        },
        {
          value: 'full_name',
          text: this.generateMessage('tech_search.fields.full_name'),
          position: 'center',
        },
        {
          value: 'entity_nav_full_id',
          text: this.generateMessage('tech_search.fields.entity_nav_full_id'),
          position: 'center',
        },
        {
          value: 'position',
          text: this.generateMessage('tech_search.fields.position'),
          position: 'center',
        },
        {
          value: 'absence_today',
          text: this.generateMessage('tech_search.fields.absence'),
          position: 'center',
        },
        {
          value: 'company_subcontractor_name',
          text: this.generateMessage(
            'tech_search.fields.company_subcontractor_name'
          ),
          position: 'center',
        },
        {
          value: 'activity_field',
          text: this.generateMessage('tech_search.fields.activity_field'),
          position: 'center',
        },
        {
          value: 'phone',
          text: this.generateMessage('tech_search.fields.phone'),
          position: 'center',
        },
        {
          value: 'specific_status',
          text: this.generateMessage('tech_search.fields.techStatus'),
          position: 'center',
        },
        {
          value: 'specific_position',
          text: this.generateMessage('tech_search.fields.roles'),
          position: 'center',
        },
        {
          text: this.generateMessage('requests.fields.action'),
          value: 'action',
          sortable: false,
        },
      ].map((item) => {
        return { ...item, class: 'secondarybackground' };
      }),
      headers: [
        {
          value: 'employee_id',
          text: this.generateMessage('tech_search.fields.employee_id'),
          position: 'center',
        },
        {
          value: 'full_name',
          text: this.generateMessage('tech_search.fields.full_name'),
          position: 'center',
        },
        {
          value: 'entity_nav_full_id',
          text: this.generateMessage('tech_search.fields.entity_nav_full_id'),
          position: 'center',
        },
        {
          value: 'position',
          text: this.generateMessage('tech_search.fields.position'),
          position: 'center',
        },
        {
          value: 'company_subcontractor_name',
          text: this.generateMessage(
            'tech_search.fields.company_subcontractor_name'
          ),
          position: 'center',
        },
        {
          value: 'activity_field',
          text: this.generateMessage('tech_search.fields.activity_field'),
          position: 'center',
        },
        {
          value: 'phone',
          text: this.generateMessage('tech_search.fields.phone'),
          position: 'center',
        },
        {
          text: this.generateMessage('requests.fields.action'),
          value: 'action',
          sortable: false,
        },
      ].map((item) => {
        return { ...item, class: 'secondarybackground' };
      }),
      mapView: false,
      name: null,
      id: '',
      type: [],
      role: [],
      scheduled: [],
      specialTechnicians: {
        mntRecourseTech: {},
        mntResponsibleTech: {},
        mntResponsibleTechBuddy: {},
        onCallTechs: [],
        onCallEndTechs: [],
        techInCharge: {},
      },
      pageSize: 25,
      pageIndex: 1,
      roles: [
        {
          id: 'mntResponsibleTech',
          name: 'Responsable de maintenance',
          shortname: 'RM',
        },
        {
          id: 'mntResponsibleTechBuddy',
          name: 'Binôme',
          shortname: 'BIN',
        },
        {
          id: 'mntRecourseTech',
          name: 'Technicien de recours',
          shortname: 'REC',
        },
        {
          id: 'techInCharge',
          name: 'Technicien en charge',
          shortname: 'DI',
        },
        {
          id: 'onCallTechs',
          name: 'Astreinte',
          shortname: 'AST',
          multiple: true,
        },
        {
          id: 'onCallEndTechs',
          name: 'FIN Astreinte',
          shortname: 'FAST',
          multiple: true,
        },
      ],
    };
  },
  /* filters: {
    transformDate,
    getStatus,
  }, */
};
</script>
